// extracted by mini-css-extract-plugin
export var animationContainer = "_gt-0";
export var footer = "_gt-1";
export var gray = "_gt-2";
export var lineItem = "_gt-3";
export var lineItemImage = "_gt-4";
export var lineItemInfo = "_gt-5";
export var lineItemText = "_gt-6";
export var lineItems = "_gt-7";
export var modalContent = "_gt-8";
export var options = "_gt-9";
export var orderName = "_gt-a";
export var refundAmount = "_gt-b";